import { useTranslation } from "react-i18next";
import { useMemo, useEffect } from "react";
import moment from "moment";
import "moment/locale/lt";

// Set to false to restore the old per-language formats (en: DD/MM/YYYY,
// datetimeFormatExpanded for incidents). Toggle this single flag to roll back.
const USE_LT_FORMAT_FOR_EN = true;

const useDateFormat = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  useEffect(() => {
    moment.locale(lang === "lt" ? "lt" : "en");
  }, [lang]);

  const dateFormat = useMemo(
    () =>
      lang === "en" && !USE_LT_FORMAT_FOR_EN ? "DD/MM/YYYY" : "YYYY-MM-DD",
    [lang]
  );

  const datetimeFormat = useMemo(
    () =>
      lang === "en" && !USE_LT_FORMAT_FOR_EN
        ? "DD/MM/YYYY HH:mm"
        : "YYYY-MM-DD HH:mm",
    [lang]
  );

  const datetimeFormatExpanded = useMemo(() => "YYYY MMM DD, HH:mm", []);

  const incidentDatetimeFormat = useMemo(
    () =>
      lang === "lt" || USE_LT_FORMAT_FOR_EN
        ? "YYYY-MM-DD HH:mm"
        : datetimeFormatExpanded,
    [lang, datetimeFormatExpanded]
  );

  return {
    dateFormat,
    datetimeFormat,
    datetimeFormatExpanded,
    incidentDatetimeFormat,
  };
};

export default useDateFormat;
